import { useContext, useMemo } from "react"

import { ensureArray } from "shared/lib/arrayUtils"

import { InputContext } from "../Input"

export function useInputDescriptionIDs({
  additionalDescriptions
}: {
  additionalDescriptions?: string | string[]
} = {}) {
  const context = useContext(InputContext)

  const descriptionIDs = useMemo(
    () => [...context.descriptionIDs, ...ensureArray(additionalDescriptions)],
    [context.descriptionIDs, additionalDescriptions]
  )

  const ariaDescribedBy = useMemo(
    () => (descriptionIDs.length > 0 ? descriptionIDs.join(" ") : undefined),
    [descriptionIDs]
  )

  return {
    descriptionIDs,
    ariaDescribedBy
  }
}
